import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { RootIntervalVertex } from '../interfaces/vertices/root-intervals';

export default (
  rootIntervals: Types.Mixed.RootInterval[],
  options:       BaseOptions
): OutTypes.rootInterval[] => {
  return rootIntervals
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<RootIntervalVertex> = {
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<RootIntervalVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
